import React from 'react';
import * as style from '../Hooks/style';
import Particles from 'react-particles-js';
import particlesConfig from '../Hooks/particlesConfig';

export const Sect1 = ({fref}) => {
  // const edge = /Edge/.test(navigator.userAgent);

  return (
    <style.Section1 ref={fref}>
      {/* { edge ? null : (<CanvasBGRays />) } */}
      <style.styledDigitalParticles>
        <Particles height="100vh" width="100%" params={particlesConfig} />
      </style.styledDigitalParticles>
      <section>
        <style.Logo />
        <p>The Maritime Technology Of Tomorrow</p>
      </section>
    </style.Section1>
  );
}
